import * as React from "react";
import { ShiftsCrews } from "./ShiftsCrewsPage";

type Props = {};

const ShiftsCrewsPage = (props: Props) => {
	return <ShiftsCrews />;
};

export default ShiftsCrewsPage;
